'use strict';

frontendApp.controller('ResetPasswordButtonCtrl', ['$scope', '$uibModal', 'NotificationService', function($scope, $uibModal, NotificationService) {

    $scope.openResetPasswordDialog = function() {

        NotificationService.dismissAll();

        $uibModal.open({
            backdrop: true,
            keyboard: true,
            backdropClick: true,
            templateUrl:  'partials/dialog_reset_password.html',
            controller: 'ResetPasswordModalCtrl'
        });
    };
    
}]);    
